import { format as DateFnsFormat } from 'date-fns';

export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
export const SHORT_READABLE_DATE_FORMAT = 'MMM dd, yyyy';

export const convertToDate = (date: Date | string) =>
    date instanceof Date ? date : new Date(date);

export const format = (date: Date | string, dateFormat?: string): string => {
    date = convertToDate(date);
    return DateFnsFormat(date, dateFormat ?? DEFAULT_DATE_FORMAT);
};

// There are manual tests for this function -- see ./tests/dateUtils.test.ts
// This function is intended for 'live' formatting of a date string as its being typed into an input
// It normalizes the date format into MM/dd/yyyy as the user types, and works whether or not the user provides a separator
export const formatTextInputAsDate = (_: string, text: string): string => {
    if (text.length === 0) return '';

    // only use / as separator in date. If we accidentally produce //, replace with /
    text = text.replace('-', '/').replace('//', '/');

    if (text.length === 1) {
        if (text === '0' || text === '1') return text; // if 0 or 1, return as is so the user may provide the next digit or a /
        return `0${text}/`; // if any number other than 0 or 1, add 0 in front
    }

    if (text === '1/') return '01/';

    if (text.length === 3 && text[2] !== '/') {
        return `${text[0]}${text[1]}/${text[2]}`;
    }

    if (text.length === 4 && text[2] === '/') {
        if (['0', '1', '2', '3'].includes(text[3] ?? '')) {
            return text; // if the last char is a 0-3, return as is so the user may provide the next digit or a /
        }
        return `${text.slice(0, 3)}0${text[3]}/`; // if the last char is not 0 or 1, add 0 in front
    }

    // if the input is 5 chars, specifically "MM/d/", then add a 0 in front of d so it will be "MM/dd/"
    if (
        text.length === 5 &&
        ['1', '2', '3'].includes(text[3] ?? '') &&
        text[4] === '/'
    ) {
        return `${text.slice(0, 3)}0${text[3]}/`;
    }

    // if the input is 6 chars, specifically MM/ddx, and x is not '/', then add 2nd '/' before 'x'
    if (text.length === 6 && text[2] === '/' && text[5] !== '/') {
        return `${text[0]}${text[1]}/${text[3]}${text[4]}/${text[5]}`;
    }

    return text;
};
